import { EventEmitter } from "events";
import dispatcher from "../dispatchers/dispatcher";

class CommonStores extends EventEmitter {
    constructor() {
        super();
        this.initData();
    }
    initData() {
        this.s3URLs = "";
    }
    _setGeneratedS3Url(urls) {
        this.s3URLs = urls;
        this.emit("change", "generatedS3Url");
    }
    _getGeneratedS3Url() {
        return this.s3URLs;
    }

    _handleActions(action) {
        switch (action.type) {
            case "S3_URL_GENERATED": {
                this._setGeneratedS3Url(action.response);
                break;
            }
        }
    }
}
const commonStores = new CommonStores();
dispatcher.register(commonStores._handleActions.bind(commonStores));
window.dispatcher = dispatcher;
export default commonStores;
